import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotSection() {
  const hotComics = [...comics].sort((a, b) => {
    const viewsA = parseFloat(a.views.replace('亿', '0000').replace('万', ''));
    const viewsB = parseFloat(b.views.replace('亿', '0000').replace('万', ''));
    return viewsB - viewsA;
  }).slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最受欢迎的漫画，大家都在看</p>
          </div>
          <Link
            to="/category/rexue"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        </div>

        <div className="flex gap-4 overflow-x-auto scrollbar-hide pb-2">
          {hotComics.map((comic) => (
            <ComicCard
              key={comic.id}
              id={comic.id}
              title={comic.title}
              author={comic.author}
              cover={comic.cover}
              category={comic.category}
              categories={comic.categories}
              rating={comic.rating}
              views={comic.views}
              status={comic.status}
              chapters={comic.chapters}
              size="lg"
            />
          ))}
        </div>
      </div>
    </section>
  );
}